import { Suspense, lazy } from 'react';
import '@project/App.scss';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Layout from '@features/Layout/Layout';
import LoadingScreen from '@components/Loading/LoadingScreen/LoadingScreen';
import ProtectedRouteWrapper from './components/RouteHelpers/ProtectedRouteWrapper';
import { NotificationProvider } from './contexts/NotificationContext';
import { NavigationProvider } from './contexts/NavigationContext';
import { SearchSidebarProvider } from './contexts/SearchSidebarContext';
const DigitalResourcesPage = lazy(() => import('@pages/DigitalResources/DigitalResourcesPage'));
const SearchPage = lazy(() => import('@pages/Search/SearchPage'));
const PDFviewer = lazy(() => import('@pages/PDFviewer/PDFviewer'));
const DigitalResourcesLearnMorePage = lazy(
  () => import('@project/pages/DigitalResources/DigitalResourcesLearnMore/DigitalResourcesLearnMorePage')
);
const MySubscriptionRoutes = lazy(() => import('./pages/MySubscription/MySubscriptionRoutes'));

function App() {
  return (
    <div className="App" data-testid="app">
      <NotificationProvider>
        <NavigationProvider>
          <SearchSidebarProvider>
            <BrowserRouter>
              <Layout>
                <Suspense fallback={<LoadingScreen />}>
                  <Routes>
                    <Route path="/" element={<DigitalResourcesPage />} />
                    <Route element={<ProtectedRouteWrapper />}>
                      <Route path="/subscription/*" element={<MySubscriptionRoutes />} />
                    </Route>
                    <Route path="/search" element={<SearchPage />} />
                    <Route path="/resource/:id" element={<DigitalResourcesLearnMorePage />} />
                    <Route path="/pdf/:id" element={<PDFviewer />} />
                  </Routes>
                </Suspense>
              </Layout>
            </BrowserRouter>
          </SearchSidebarProvider>
        </NavigationProvider>
      </NotificationProvider>
    </div>
  );
}

export default App;
